export {
  default as LinearGradient,
  LinearGradientProps,
  LinearGradienPoint,
} from './LinearGradient';
